export const BPC = {
    ESTIMATE: 'Estimate',
    PLAYERS: 'Players',
    SHOW: 'Show',
};
